import { applicationVersionDetail, applicationVersionSchedule, reviewApprove } from './request';
export default {
  data() {
    return {
      scheduleList: [],
      dataFrom: {},
      from: {},
      dialogVisible: false
    };
  },
  methods: {
    init(data) {
      this.from.nodeId = data.nodeId;
      applicationVersionSchedule({
        versionId: data.versionId
      }).then(res => {
        this.scheduleList = res;
      });
      applicationVersionDetail({
        nodeId: data.nodeId
      }).then(res => {
        console.log(res);
        this.dataFrom = res;
      });
      this.dialogVisible = true;
    },
    onSubmit(status) {
      if (!this.from.content) {
        this.$message.error(this.$t('请输入') + this.$t('审核意见'));
        return false;
      }
      this.from.status = status;
      reviewApprove(this.from).then(res => {
        this.$message.success(this.$t('操作成功') + '!');
        this.$emit('cancel');
        this.$emit('ok');
      });
    }
  }
};